import React from "react";
import { StyledIconButton } from "../styled/StyledIconButton.styled";
import { SiMicrosoftexcel } from "react-icons/si";
import PropTypes from "prop-types";
import {
  BsFileEarmarkArrowDownFill,
  BsFileEarmarkArrowUpFill,
} from "react-icons/bs";
import { Data } from "../styled/StyledTable.styled";
export default function File({ fileName, handleClick, zip, upload, disabled }) {
  if (upload)
    return (
      <StyledIconButton
        aria-controls="basic-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
      >
        <BsFileEarmarkArrowUpFill style={{ fontSize: "25px" }} />
      </StyledIconButton>
    );
  return (
    <div>
      {fileName && (
        <StyledIconButton
          aria-controls="basic-menu"
          aria-haspopup="true"
          onClick={handleClick}
          disabled={disabled}
        >
          {zip ? (
            <BsFileEarmarkArrowDownFill style={{ fontSize: "25px" }} />
          ) : (
            <>
              <SiMicrosoftexcel
                style={{ marginRight: "20px", fontSize: "25px" }}
              />
              {fileName}
            </>
          )}
        </StyledIconButton>
      )}
      {!fileName && <Data>N/A</Data>}
    </div>
  );
}

File.propTypes = {
  fileName: PropTypes.string,
  handleClick: PropTypes.func,
};

File.defaultProps = {
  fileName: null,
  handleClick: () => {},
};
